import { getWebSocketRuntimeUrl } from "./runtimeBaseUrl";

// WebSocket URL helper for development and production
export function getWebSocketUrl() {
  // In development, use environment variable or localhost
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  return getWebSocketRuntimeUrl(window.location);
}
